import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=9a24139a&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=9a24139a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24139a",
  null
  
)

export default component.exports